import React, { FormEvent, ReactNode } from "react";
import { Box, SxProps, Theme } from "@mui/material";
import BoxComponent from "../Box/BoxComponent";

interface FormComponentProps {
    children: ReactNode;
    onSubmit?: (event: FormEvent<HTMLFormElement>) => void;
    sx?: SxProps<Theme>;
}

const FormComponent = (props: FormComponentProps) => {
    return (
        <BoxComponent
            component="form"
            onSubmit={props.onSubmit}
            sx={props.sx}
        >
            {props.children}
        </BoxComponent>
    );
};

export default FormComponent;